import React from 'react';

import { LanguageSelector } from '../language-selector';

export const LanguageSelectorReduxFormComponent = ({ input }: ReduxFormFieldProps<string>) => (
  <LanguageSelector
    value={input.value || ''}
    label="Language Preference"
    onChange={input.onChange}
  />
);
